import { InjectionToken } from '@angular/core';


/** Applications can replace the video dialog with their documentation links. */
export interface ISparkHelpDocumentation {
	getUrl(route?: string): string;
	openLink(event: MouseEvent, url: string): void;
}

export const SPARK_HELP_DOCUMENTATION: InjectionToken<ISparkHelpDocumentation> = new InjectionToken<ISparkHelpDocumentation>('SPARK_HELP_DOCUMENTATION');
